(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function formatearDinero(centimos, formato) {
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = (formato || '').match(re);
    function d(n, dec, miles, sep) {
      miles = miles || ','; sep = sep || '.';
      var partes = (n / 100).toFixed(dec).split('.');
      var entero = partes[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + miles);
      return entero + (partes[1] ? sep + partes[1] : '');
    }
    if (!m) return (centimos / 100).toFixed(2);
    var valor;
    switch (m[1]) {
      case 'amount_no_decimals': valor = d(centimos, 0); break;
      case 'amount_with_comma_separator': valor = d(centimos, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': valor = d(centimos, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': valor = d(centimos, 2, "'", '.'); break;
      case 'amount_with_space_separator': valor = d(centimos, 2, ' ', ','); break;
      default: valor = d(centimos, 2);
    }
    return formato.replace(re, valor);
  }

  function crear(tag, clase, texto) {
    var el = document.createElement(tag);
    if (clase) el.className = clase;
    if (texto != null) el.textContent = texto;
    return el;
  }

  function iniciar(root) {
    if (!root || root.dataset.clListo) return;
    root.dataset.clListo = '1';

    var datos = {};
    var nodoDatos = root.querySelector('[data-cl-datos]');
    if (nodoDatos) { try { datos = JSON.parse(nodoDatos.textContent); } catch (e) {} }
    var producto = datos.producto;

    /* Galería */
    var slides = root.querySelector('[data-cl-slides]');
    var irA = function () {};
    if (slides) {
      var thumbs = root.querySelectorAll('[data-cl-thumb]');
      irA = function (i) {
        var s = slides.children[i];
        if (s) slides.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
      };
      var indiceActual = function () { return Math.round(slides.scrollLeft / slides.clientWidth); };
      var marcar = function () {
        var i = indiceActual();
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-activa', n === i);
          if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
      };
      var temporizador;
      slides.addEventListener('scroll', function () { clearTimeout(temporizador); temporizador = setTimeout(marcar, 60); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { irA(+t.dataset.clThumb); }); });
      var total = slides.children.length;
      var prev = root.querySelector('[data-cl-prev]');
      var next = root.querySelector('[data-cl-next]');
      if (prev) prev.addEventListener('click', function () { irA((indiceActual() - 1 + total) % total); });
      if (next) next.addEventListener('click', function () { irA((indiceActual() + 1) % total); });
    }

    /* Variantes */
    var form = root.querySelector('[data-cl-form]');
    var botonAdd = root.querySelector('[data-cl-add]');
    if (form && producto) {
      var input = form.querySelector('[data-cl-variante]');
      var radios = root.querySelectorAll('[data-cl-pos]');
      var precio = root.querySelector('[data-cl-precio]');
      var antes = root.querySelector('[data-cl-precio-antes]');
      var ahorro = root.querySelector('[data-cl-ahorro]');
      var textoAdd = root.querySelector('[data-cl-add-texto]');
      var formato = datos.formatoMoneda;

      var buscarVariante = function () {
        var sel = [];
        radios.forEach(function (r) { if (r.checked) sel[+r.dataset.clPos] = r.value; });
        return producto.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        });
      };

      var pintar = function (v) {
        if (!v) {
          botonAdd.disabled = true;
          textoAdd.textContent = botonAdd.dataset.textoAgotado;
          return;
        }
        input.value = v.id;
        if (precio) precio.textContent = formatearDinero(v.price, formato);
        var hayRebaja = v.compare_at_price && v.compare_at_price > v.price;
        if (antes) { antes.hidden = !hayRebaja; if (hayRebaja) antes.textContent = formatearDinero(v.compare_at_price, formato); }
        if (ahorro) {
          ahorro.hidden = !hayRebaja;
          if (hayRebaja) ahorro.textContent = ahorro.dataset.prefijo + ' ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
        }
        botonAdd.disabled = !v.available;
        textoAdd.textContent = v.available ? botonAdd.dataset.textoOk : botonAdd.dataset.textoAgotado;
        if (v.featured_media && slides) {
          var objetivo = slides.querySelector('[data-media-id="' + v.featured_media.id + '"]');
          if (objetivo) irA(Array.prototype.indexOf.call(slides.children, objetivo));
        }
        if (/\/products\//.test(location.pathname) && window.history && history.replaceState) {
          var url = new URL(location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      };

      radios.forEach(function (r) { r.addEventListener('change', function () { pintar(buscarVariante()); }); });
    }

    /* Botones "Comprar ahora": envían el formulario principal */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cl-comprar]');
      if (!b || !botonAdd) return;
      e.preventDefault();
      if (botonAdd.disabled) {
        botonAdd.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        botonAdd.click();
      }
    });

    /* Barra fija */
    var barra = root.querySelector('[data-cl-barra]');
    if (barra && botonAdd && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        var en = entradas[0];
        barra.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(botonAdd);
    }

    /* Productos recomendados */
    var recos = root.querySelector('[data-cl-recomendados]');
    if (recos) {
      var seccion = recos.closest('.cl-sec');
      if (!producto) { if (seccion) seccion.hidden = true; return; }
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var limite = recos.dataset.limite || 4;
      fetch(base + 'recommendations/products.json?product_id=' + producto.id + '&limit=' + limite + '&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var lista = (d && d.products) || [];
          if (!lista.length) { if (seccion) seccion.hidden = true; return; }
          lista.forEach(function (pr) {
            var a = crear('a', 'cl-reco');
            a.href = pr.url;
            if (pr.featured_image) {
              var img = crear('img');
              var src = pr.featured_image;
              img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=500';
              img.alt = pr.title;
              img.loading = 'lazy';
              a.appendChild(img);
            }
            a.appendChild(crear('p', 'cl-reco__titulo', pr.title));
            a.appendChild(crear('span', 'cl-reco__precio', formatearDinero(pr.price, datos.formatoMoneda)));
            if (pr.compare_at_price && pr.compare_at_price > pr.price) {
              a.appendChild(crear('span', 'cl-reco__antes', formatearDinero(pr.compare_at_price, datos.formatoMoneda)));
              var pct = Math.round((pr.compare_at_price - pr.price) * 100 / pr.compare_at_price);
              a.appendChild(crear('span', 'cl-reco__dto', pct + '% ' + (recos.dataset.textoDto || 'DTO')));
            }
            recos.appendChild(a);
          });
        })
        .catch(function () { if (seccion) seccion.hidden = true; });
    }
  }

  function iniciarTodo() { document.querySelectorAll('[data-cl]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarTodo);
  else iniciarTodo();
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target.querySelector('[data-cl]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
